<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="airlines.icon" class="mr-1"></i>
            <span>{{ airlines.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Code" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="airlines.debounce" placeholder="Code"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="airlines.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Prefix?" label-size="sm">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="prefixempty" v-model="prefixempty" :options="options_prefixempty"
                      size="sm" value-field="id" text-field="label" name="radio-options" class="z-0"
                      style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group>
                    <b-form-input v-model="prefix" :debounce="airlines.debounce" placeholder="Prefix"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!prefix" @click="prefix = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="ICAO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="icao" :debounce="airlines.debounce" placeholder="ICAO"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!icao" @click="icao = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Territory" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="territory" :debounce="airlines.debounce"
                      placeholder="Territory"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!territory" @click="territory = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Oneworld?" label-for="oneworld" label-cols="12">
                  <treeselect instanceId="oneworld" type="number" v-model="oneworld" :clearable="true"
                    :options="oneworld_options"></treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="airlines" :icon="airlines.icon" :busy="airlines.busy"
            :toolbarlibrary="airlines.toolbarlibrary" :tools="airlines.tools" :badges="airlines.badges"
            :fields="airlines.fields" :items="airlines.items" :limit="airlines.limit" :downloaded="airlines.downloaded"
            :showpages="true" :offset="airlines.offset" :page="airlines.page" @load="airlines_load"
            @click="airlines_click" @changed="airlines_click('save', $event)" @select="airlines_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="airlines.selected" :config="cconfig" @discard="airlines_click('discard')"
          @go="airlines_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import AirlinesEdit from "./Components/Setup_AirlinesEdit";

export default {
  name: "Airlines",
  components: { AirlinesEdit },
  watch: {
    async code() {
      console.log("code", this.code);
      await this.airlines_load(0);
    },
    async description() {
      console.log("description", this.description);
      await this.airlines_load(0);
    },
    async prefix() {
      console.log("prefix", this.prefix);
      await this.airlines_load(0);
    },
    async prefixempty() {
      console.log("prefixempty", this.prefixempty);
      await this.airlines_load(0);
    },
    async icao() {
      console.log("icao", this.icao);
      await this.airlines_load(0);
    },
    async territory() {
      console.log("territory", this.territory);
      await this.airlines_load(0);
    },
    async oneworld() {
      console.log("oneworld", this.oneworld);
      await this.airlines_load(0);
    },
  },
  data() {
    return {
      code: null,
      description: null,
      prefix: null,
      territory: null,
      icao: null,
      prefixempty: null,
      options_prefixempty: [
        { id: "", label: "Default" },
        { id: "true", label: "No" },
        { id: "false", label: "Yes" },
      ],
      oneworld: null,
      oneworld_options: [
        {
          id: "1",
          label: "Yes",
        },
        {
          id: "0",
          label: "No",
        },
      ],

      airlines: {
        title: "Airlines",
        icon: "fa fa-plane",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "code",
            label: "Code",
            sortable: true,
          },
          {
            key: "prefix",
            label: "Prefix",
            sortable: true,
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "icao",
            label: "ICAO",
            sortable: true,
          },
          {
            key: "territory",
            label: "Territory",
            sortable: true,
          },
          {
            key: "oneworld",
            label: "Oneworld",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "oneworld",
            type: "badge",
            Yes: "success",
            No: "danger",

            formatter: (value, key, item) => {
              switch (value) {
                case "1":
                  return "Yes";

                case "0":
                  return "No";

                default:
                  return value;
              }
            },
          },

        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.airlines_load();
  },

  methods: {
    accessdenied() {
      this.airlines.denied = [];
      if (!this.user.permissions.includes("setup_airlines.admin")) {
        this.airlines.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_airlines.admin")) {
        this.airlines.denied.push("add");
        this.airlines.denied.push("save");
      }

    },


    async airlines_load(offset, limit, page) {
      let state = this.airlines;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        code: this.code,
        description: this.description,
        prefix: this.prefix,
        prefixempty: this.prefixempty,
        icao: this.icao,
        territory: this.territory,
        oneworld: this.oneworld,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_airlines(
                $limit: Int
                $offset: Int
                $id: String
                $description: String
                $prefix: String
                $prefixempty: String
                $icao: String
                $territory: String
                $code: String
                $oneworld: String
                $dateformat: String      
              ) {
                setup_airlines(
                  limit: $limit
                  offset: $offset
                  id: $id
                  description: $description
                  icao: $icao
                  territory: $territory
                  prefix: $prefix
                  prefixempty: $prefixempty
                  code: $code
                  oneworld: $oneworld
                  dateformat: $dateformat
                ) {
                  id
                  description
                  prefix
                  icao
                  territory
                  code       
                  oneworld
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_airlines
        } else {
          state.items = response.data.setup_airlines;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async airlines_click(a, ss) {

      let state = this.airlines;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.airlines_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.airlines_load();
          break;
        case "go":
          this.component = null;
          await this.airlines_load();
          break;
        case "add":
        case "edit":
          this.component = "AirlinesEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async airlines_select(ss, tools) {

      let state = this.airlines;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_airlines_save(
                $rows: [setup_airlines_input]             
              ) {
                setup_airlines_save(rows: $rows) {
                  id
                description
                code         
                oneworld
                prefix
                icao
                territory
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_airlines_delete(
                $rows: [setup_airlines_input]
              ) {
                setup_airlines_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.airlines_load(0);
    },
  },
};
</script>

<style scoped></style>